import {useListView} from './core/ListViewProvider'
import {LicensesTable} from './table/LicensesTable'
import {KTCard} from '../../../../../../_metronic/helpers'
import {LicensesListHeader} from './components/header/LicensesListHeader'
interface props {
  data?: any
  onDataFromChild: (data: any) => void
}

// const LicensesListWrapper = (data: any, onDataFromChild: any) => {
const LicensesListWrapper: React.FC<props> = ({data, onDataFromChild}) => {
  const {itemIdForUpdate} = useListView()
  const handleDataFromChild = (data2: any): void => {
    onDataFromChild(data2)
  }
  return (
    <>
      <KTCard>
        <LicensesListHeader data={data} onDataFromChild={handleDataFromChild} />
      </KTCard>

      <div className='py-3'>
        <KTCard>
          <LicensesTable />
        </KTCard>
      </div>
      {itemIdForUpdate !== undefined}
    </>
  )
}

export {LicensesListWrapper}
